import { useEffect, useState } from 'react';
import { off, subscribe } from '../helpers/subscription';
import { globalState } from '../internal/stateContainer';
export function useSelector(selector) {
    var _a = useState(function () { return selector(globalState); }), value = _a[0], setValue = _a[1];
    useEffect(function () {
        var subscription = subscribe(function (newState) {
            var newValue = selector(newState);
            value !== newValue && setValue(newValue);
        });
        return function () {
            off(subscription);
        };
    }, [selector, value]);
    return value;
}
//# sourceMappingURL=useSelector.js.map